// extracted by mini-css-extract-plugin
export default {"LogoImg":"HeaderLogo_LogoImg__zfEpb"};